import { render, staticRenderFns } from "./renovarModal.vue?vue&type=template&id=206b5f46&scoped=true"
import script from "./renovarModal.vue?vue&type=script&lang=js"
export * from "./renovarModal.vue?vue&type=script&lang=js"
import style0 from "./renovarModal.vue?vue&type=style&index=0&id=206b5f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b5f46",
  null
  
)

export default component.exports